/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { ProductionProcessTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const productionProcessFetchProductionProcessLoading = (state, { boolean }) => ({
  ...state,
  processIsLoading: boolean
});

export const productionProcessFetchProductionProcessSuccess = (state, { process }) => ({
  ...state,
  process
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [ProductionProcessTypes.PRODUCTION_PROCESS_FETCH_PRODUCTION_PROCESS_LOADING]: productionProcessFetchProductionProcessLoading,
  [ProductionProcessTypes.PRODUCTION_PROCESS_FETCH_PRODUCTION_PROCESS_SUCCESS]: productionProcessFetchProductionProcessSuccess
});
